<template>
  <div class="layout__container">
    <h3 class="text__align-center text__colour-teal">Lapsed Branches</h3>
    <div class="layout__position-center">
      <div class="layout__position-left layout__width-100">
        <LapsedBranchesSearch
          :search-params="searchParams"
          :sales="sales"
        />
      </div>
      <div class="insights-table layout__width-100 layout__position-left">
        <el-table
          class="el-table__09vh"
          :data="sales"
          height="620px"
          show-summary
          :summary-method="getSummaries"
          @sort-change="handleSortOrderChange"
          v-loading.fullscreen.lock="loading"
          element-loading-text="Loading..."
          element-loading-background="rgba(79, 147, 168, 0.2)"
          empty-text="No data has been returned for the selected dates"
        >
          <el-table-column
            v-for="lapsedBranch in LapsedBranches.fields()"
            :key="`${lapsedBranch}.${new Date()}`"
            :prop="lapsedBranch"
            :show-overflow-tooltip="true"
            :min-width="LapsedBranches.getColumnWidth(lapsedBranch)"
            :label="LapsedBranches.getReadable(lapsedBranch)"
            class-name="layout__width-150px el-table-column__no-pointer"
            sortable="custom"
          />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment';
import Axios from 'axios';
import LapsedBranchesSearch from '@/components/insights/LapsedBranchesSearch';
import { axios } from '@/mixins/Axios.js';
import { csvDownloadHelper } from '@/mixins/CsvDownloadHelper.js';
import { dataFormatter } from '@/mixins/DataFormatter.js';
import { sortJsonArrayHelper } from '@/mixins/sort-json-array.js';
import LapsedBranches from '../../../enums/LapsedBranches';

export default {
  name: 'LapsedBranchesReport',

  mixins: [
    axios,
    csvDownloadHelper,
    dataFormatter,
    sortJsonArrayHelper,
  ],

  components: {
    LapsedBranchesSearch,
  },

  props: {
    view: ''
  },

  data() {
    return {
      selectedStartDate: '',
      selectedEndDate: '',
      selectedTerritory: '',
      selectedCustomer: '',
      sales: [],
      loading: false,
      loadings: {},
      LapsedBranches: LapsedBranches,
      serviceRouteUrl: `${process.env.VUE_APP_INSIGHTSAPIHOST}`,
      exportDate: new Date().toLocaleDateString('en-GB') + '_sales.csv',
      searchParams: {
        salesDateRange: [
          moment(moment().subtract(1, 'M')).startOf('month').format('YYYY-MM-DD'),
          moment(moment().subtract(1, 'M')).endOf('month').format('YYYY-MM-DD'),
        ],
      },
    };
  },

  created() {
    console.log('LapsedBranches');
    this.isUserAuthorised();
  },

  methods: {
    getCurrencyAmount(row, column, cellValue) {
      if (typeof cellValue === 'undefined') {
        return '£0';
      } else {
        return '£' + cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    },

    handleSortOrderChange(sortProps) {
      console.log('prop: ' + sortProps.prop);
      console.log('order: ' + sortProps.order);

      this.sortJsonArray(this.sales, sortProps.prop, sortProps.order.slice(0, 3));
    },

    getSummaries(param) {
      const columnsToSum = ['Quantity', 'Orders Count', 'Total', 'Gross Total'];
      const columnsToAddCurrency = ['Total', 'Gross Total'];
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        // var noTotalCols = ['Month', 'Year'];
        // if (noTotalCols.indexOf(column.label) >= 0) {
        //   sums[index] = '';
        //   return;
        // }
        if (columnsToSum.indexOf(column.label) < 0) {
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        let isCurrency = columnsToAddCurrency.indexOf(column.label) >= 0;
        if (! values.every(value => isNaN(value))) {
          sums[index] = (isCurrency ? '£' : '') + this.returnWithCommas(values.reduce((prev, curr) => {
            const value = Number(curr);
            if (! isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0).toFixed(isCurrency ? 2 : 0));
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },

    csv(index, row) {
      this.selectedStartDate = new Date(row.year, row.month - 1, 1);
      this.selectedEndDate = new Date(row.year, row.month, 0);
      this.selectedTerritory = encodeURIComponent(row.territory);
      this.selectedCustomer = encodeURIComponent(row.customer);

      console.log('this.selectedStartDate:' + this.selectedStartDate);
      console.log('this.selectedEndDate:' + this.selectedEndDate);
      console.log('this.selectedTerritory:' + this.selectedTerritory);
      console.log('this.selectedCustomer:' + this.selectedCustomer);

      console.log('before');
      console.log(this.searchParams);

      let searchTerms = Object.assign({}, this.searchParams);
      console.log('searchTerms');
      console.log(searchTerms);

      console.log('after search is copied');
      console.log(this.searchParams);

      console.log('after search is copied - new object');
      console.log(searchTerms);

      var startDateArray = searchTerms.salesDateRange[0].split('/'),
        startDate = moment(new Date(startDateArray[1], startDateArray[0] - 1, 1)).format('YYYY%2FMM%2FDD'),
        endDateArray = searchTerms.salesDateRange[1].split('/'),
        endDate = moment(new Date(endDateArray[1], endDateArray[0], 0)).format('YYYY%2FMM%2FDD'),
        endpoint = this.serviceRouteUrl + '/api/v1/DynamicQuery/GetLapsedCustomers?startDate=' + startDate + '&endDate=' + endDate;

      console.log(endpoint);

      this.$set(this.loadings, index, false);

      Axios.get(endpoint, this.returnHeaderUsingToken())
        .then(response => {
          const fields = this.lapsedBranches.createLabelValueList();

          this.downloadCsv(this.exportDate, fields, response.data);

          this.$nextTick(() => { // Loading should be closed asynchronously
            this.$set(this.loadings, index, false);
          });
        })
        .catch(error => {
          if (error.response) {
            this.$message.error('Sorry there has been an issue retrieving the information you requested.');
          }

          this.$nextTick(() => { // Loading should be closed asynchronously
            this.$set(this.loadings, index, false);
          });
        });
    }
  }
};
</script>